import { Routes } from '@angular/router';
import { AuthRoutes } from './views/auth/auth.routing';

export const routes: Routes = [
    {
        path:'',loadComponent:()=> import('./views/auth/auth.component').then(m => m.AuthComponent ),children: AuthRoutes,
    }     
];
